import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, SvgIcon } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import FileInput from '../../../common/fileInput'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { dataDummyRateCrossing } from './dummyConstans'
import { rateCrossingHead } from './rateMatrixConstants'
import { CancelIcon } from '../../../common/svg'
import { useTranslation } from '../../../../i18n/I18nProvider'

const RateCrossingBulkUpdate = (props) => {
  const { data } = props
  const theme = useTheme()
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const t = (key, fallback) => gs?.[key] || fallback
  const translatedRateCrossingHead = rateCrossingHead.map((col) => ({ ...col, headerName: t(col.translationKey, col.headerName) }))
  const { common } = data
  const { loginData } = common

  const [serviceTypeList, setServiceTypeList] = useState(dataDummyRateCrossing)
  const [fileData, setFileData] = useState(null)
  const StyledCancel = ({ active, ...rest }) => {
    return (
      <div style={{ color: active ? theme.palette.primary.main : theme.palette.text.disabled }} {...rest}>
        <CancelIcon fillColor={active ? theme.palette.primary.main : theme.palette.text.disabled} /> {t('cancel', 'Cancel')}
      </div>
    )
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0' }}>
        <Item sx={{ ...sx.itemsx }} className="">
          <Button
            variant="contained"
            id={'add_btn'}
            color="secondary"
            sx={{ width: '100%', fontSize: '16px' }}
            className="receiveitembtn"
            startIcon={<CloudDownloadIcon />}
            onClick={() => {}}
          >
            {t('rateMasterSample', 'Rate master sample')}
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx, minWidth: '50%', margin: '0 10px' }} className="disabled-wrapper">
          <FileInput
            id={''}
            label={t('uploadRateCrossingBulkFile', 'Upload Rate Crossing Bulk File')}
            keepLabel={true}
            fileChange={setFileData}
            accept={'.xls, .xlsx, .jpg'}
            value={''}
            styleProps={{ width: '100%' }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx }} className="">
          <Button
            variant="outlined"
            color="secondary"
            id={'add_btn'}
            sx={{ width: '100%' }}
            className="receiveitembtn"
            startIcon={<CloudUploadIcon style={{ color: theme.palette.secondary.main }} />}
            onClick={() => {}}
          >
            {t('upload', 'UPLOAD')}
          </Button>
        </Item>
      </Box>
      <TableContainer component={Paper} style={{ marginBottom: '5px' }}>
        {serviceTypeList.length > 0 && (
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '&.MuiTableCell-root': {
                padding: '6px 8px!important',
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {translatedRateCrossingHead.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      minHeight: '36px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#444',
                      height: '36px',
                      fontSize: '12px',
                      padding: '6px 10px',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {serviceTypeList.length > 0 && (
              <TableBody>
                {serviceTypeList.map((item, index) => (
                  <TableRow key={index}>
                    {translatedRateCrossingHead.map((col, index) => (
                      <TableCell key={`TC-${index}`} sx={{ ...col.headerSx, padding: '6px 10px', height: '36px', fontSize: '12px' }}>
                        {col.field === 'action' && <StyledCancel active={item[col.field] === 'CancelActive'} />}
                        {!['action'].includes(col.field) && item[col.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        )}
      </TableContainer>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(RateCrossingBulkUpdate)
